import { LieuResponseDto } from '../dtos/lieu/lieu.response.dto';
import { LieuRequestDto } from '../dtos/lieu/lieu.request.dto';
import { TypeLieuDto } from '../dtos/lieu/type-lieu.dto';
import { Lieu } from '@domain/lieu/lieu';
import { TypeLieu } from '@domain/lieu/type-lieu';

export class LieuMapper {
  static fromDto(dto: LieuResponseDto): Lieu {
    return new Lieu(
      dto.id,
      dto.nom,
      dto.adresse,
      dto.description,
      dto.type ? LieuMapper.typeLieuFromDto(dto.type) : undefined,
      dto.nombreMaxParticipants,
    );
  }

  static toRequestDto(entity: Lieu): LieuRequestDto {
    return {
      nom: entity.nom,
      adresse: entity.adresse,
      description: entity.description,
      type: entity.type ? { id: entity.type.id, code: entity.type.code } : undefined,
      nombreMaxParticipants: entity.nombreMaxParticipants,
    };
  }

  static typeLieuFromDto(dto: TypeLieuDto): TypeLieu {
    return new TypeLieu(dto.id, dto.code ?? '');
  }
}
